import { clsx } from 'clsx'
import { type FC, type RefObject } from 'react'

import { ProductSearchResultItemGenericLabel } from './ProductSearchResultItemGenericLabel'

const PLUS = '+'

export const ProductSearchResultItemCounterLabel: FC<{
  counterRef: RefObject<HTMLDivElement | null>
  hiddenLabelsCounter: number
}> = ({ counterRef, hiddenLabelsCounter }) => {
  return (
    <div
      className={clsx('absolute', !hiddenLabelsCounter && 'hidden')}
      ref={counterRef}
    >
      <ProductSearchResultItemGenericLabel
        className="border-dark-primary-min bg-light-primary-low"
        key="counter"
      >
        {PLUS}
        {hiddenLabelsCounter}
      </ProductSearchResultItemGenericLabel>
    </div>
  )
}
